// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3K0Xx","column":"style_column__ebqF-","row":"style_row__3q42R"};